import { WebshopBackgroudGradient } from '@shared/components/Images';
import { CookieProvider } from '@shared/contexts/cookie-context';
import clsx from 'clsx';
import {
  FC, Suspense, useState,
} from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Cookies } from '../components/CookiesBanner';
import { Footer } from '../components/Footer';
import { Loader } from '../components/Loader';
import { Navbar } from '../components/Navbar';
import { RouterPathes } from '../constants/router-paths';

const CHECKOUT_PATHS = new Set([RouterPathes.offerCheckout, RouterPathes.checkoutSuccess]);

export const AppLayout: FC = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isOfferCheckout = CHECKOUT_PATHS.has(location.pathname as RouterPathes);

  return (
    <CookieProvider gtmId="GTM-TWGK4J98">
      <main
        className={clsx(
          'bg-background flex w-full flex-col bg-[#1b1f54] bg-center',
          isMobileMenuOpen ? 'h-screen overflow-hidden' : 'min-h-screen',
        )}
      >
        {isOfferCheckout && <WebshopBackgroudGradient className="absolute" />}
        <Navbar isMobileMenuOpen={isMobileMenuOpen} setMobileMenuOpen={setMobileMenuOpen} />
        <Cookies />
        <main className="flex min-h-[640px] flex-1">
          <Suspense
            fallback={(
              <div className="flex flex-1 items-center justify-center">
                <Loader width={80} height={80} />
              </div>
            )}
          >
            <Outlet />
          </Suspense>
        </main>
        <Footer />
      </main>
    </CookieProvider>
  );
};
